










































import { Vue, Component, Prop } from 'vue-property-decorator';
import { AliPay, getUserInfo } from '@/api/api';
import { Toast } from 'vant';
function judgeOs() {
  const UA = navigator.userAgent;
  if (UA.match(/iPad/) || UA.match(/iPhone/) || UA.match(/iPod/)) {
    return true;
  } else {
    return false;
  }
}
@Component
export default class AliPayButton extends Vue {
  @Prop() voteName!: string;
  @Prop() amount!: number;
  @Prop({ default: true }) canPay!: boolean;
  username: string = '';
  userid: string = '';
  tradeNo: number = Date.now();
  pointOut: boolean = false;
  get baseUrl(): string {
    if (process.env.VUE_APP_API_URL === '//voteone.cqcb.com') {
      return `http://pay.syxwvote.com/vote/${this.voteName}/pay.php`;
    } else {
      const isIOS = judgeOs();
      return isIOS
        ? `http://192.168.184.9:8019/vote/${this.voteName}/pay.php`
        : `https://testvoteone.cqcb.com/vote/${this.voteName}/pay.php`;
    }
  }
  created() {
    this.initUserInfo();
  }
  async initUserInfo() {
    // 获取用户信息
    const res = await getUserInfo(this.voteName);
    if ((res as any).code === 200) {
      console.log('获取用户信息成功');
      this.username = res.data.username;
      this.userid = res.data.userid;
    } else if (
      (res as any).code === 202 &&
      process.env.NODE_ENV === 'production'
    ) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
    }
  }
  startAlipay() {
    if (process.env.VUE_APP_ENV_NAME === 'production') {
      if (!this.judgeAmount()) {
        return;
      }
    }

    if (!this.canPay) {
      Toast.fail('现在不能充值！');
      return;
    }
    if (this.userid) {
      if (window.udid) {
        (document.getElementById('aliyun_form') as HTMLFormElement).submit();
      } else {
        this.pointOut = true;
      }
    } else {
      Toast.fail('网络繁忙');
    }
  }
  judgeAmount(): boolean {
    const temp = this.amount.toString();
    if (temp.indexOf('.') > -1) {
      Toast.fail('充值金额不能含有小数点');
      return false;
    } else if (temp.indexOf('e') > -1) {
      Toast.fail('请输入正整数');
      return false;
    } else if (temp.indexOf('-') > -1) {
      Toast.fail('请输入正整数');
      return false;
    } else if (Number(temp) === 0) {
      Toast.fail('请输入正确的充值金额');
      return false;
    }
    return true;
  }
}
